import { useQuery } from '@apollo/client'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button, ButtonType } from '@src/components/Button'
import { ErrorPage } from '@src/components/Errors/ErrorPage'
import { LoadingSpinner } from '@src/components/Loaders/LoadingSpinner'
import { Markdown } from '@src/components/Markdown/Markdown'
import { useCookieConsent } from '@src/hooks/useCookieConsent/useCookieConsent'

import { getCookiesDocument } from './queries/__generated__/getCookies.graphql-interface'

import { BurgerSection } from '../../Drawer/DrawerHeader'

export const Cookies: React.FC = () => {
  const { t } = useTranslation('policies')
  const { resetConsent } = useCookieConsent()

  const { data, loading, error } = useQuery(getCookiesDocument, {
    variables: { cname: window.location.hostname },
  })
  if (loading) return <LoadingSpinner />
  if (error || !data) return <ErrorPage />

  const cookiesCopy = data.marketplaceByCname.legalCookies

  return (
    <BurgerSection header={{ title: t('cookies') }}>
      {cookiesCopy ? (
        <Markdown markdown={cookiesCopy} twoCols />
      ) : (
        t('cookies_fallback')
      )}
      <div style={{ marginTop: 16 }}>
        <Button
          buttonType={ButtonType.SECONDARY}
          content={t('manage_cookie_preferences')}
          onClick={resetConsent}
          dataTestId="manage-cookie-preferences"
        />
      </div>
    </BurgerSection>
  )
}
